(() => {
	angular
		.module('main')
		.factory('copyToClipboardService', copyToClipboardService);

	copyToClipboardService.$inject = [
		'$compile',
		'$document',
		'$rootScope',
		'messageService'
	];

	function copyToClipboardService(
		$compile,
		$document,
		$rootScope,
		messageService
	) {
		return {
			copy
		};

		function copy(element, successMessage) {
			const copyElement = angular.element(
				'<span id="ngClipboardCopyId"></span>'
			);
			copyElement.text(element);

			const body = $document.find('body').eq(0);
			body.append($compile(copyElement)($rootScope));

			const ngClipboardElement = angular.element(
				document.getElementById('ngClipboardCopyId')
			);
			const range = document.createRange();

			range.selectNode(ngClipboardElement[0]);

			window.getSelection().removeAllRanges();
			window.getSelection().addRange(range);

			document.execCommand('copy');

			switch (successMessage) {
				case 'url':
					messageService.showToaster('i_0', 'contactForm');
					break;
				case 'embed':
					messageService.showToaster('i_1', 'contactForm');
					break;
				case 'ambassador':
				case 'referral':
					messageService.showToaster('i_0', 'promoCodes');
					break;
				default:
					toastr.info('', 'Copied');
			}

			window.getSelection().removeAllRanges();

			copyElement.remove();
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/services/copyToClipboardService.js